import Navbar from "@/components/landing/Navbar";
import Footer from "@/components/landing/Footer";

const MentionsLegales = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="container max-w-3xl py-24">
        <h1 className="text-3xl font-bold text-foreground mb-8">Mentions légales</h1>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-foreground mb-3">Éditeur du site</h2>
          <p className="text-muted-foreground leading-relaxed">
            Gregory Scafarto<br />
            12B Rue Sainte Isaure<br />
            75018 Paris, France<br />
            Email : <a href="mailto:gregory.s@coach-os.eu" className="text-accent hover:underline">gregory.s@coach-os.eu</a><br />
            SIRET : en cours d'immatriculation
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-foreground mb-3">Hébergement</h2>
          <p className="text-muted-foreground leading-relaxed">
            Vercel, Inc.<br />
            440 N Barranca Ave #4133<br />
            Covina, CA 91723, États-Unis<br />
            <a href="https://vercel.com" className="text-accent hover:underline" target="_blank" rel="noopener noreferrer">vercel.com</a>
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-foreground mb-3">Propriété intellectuelle</h2>
          <p className="text-muted-foreground leading-relaxed">
            L'ensemble du contenu de ce site (textes, images, graphismes, logo) est la propriété exclusive de Gregory Scafarto, sauf mention contraire. Toute reproduction, distribution ou utilisation sans autorisation préalable est interdite.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-foreground mb-3">Données personnelles</h2>
          <p className="text-muted-foreground leading-relaxed">
            Les données collectées sur ce site sont traitées conformément au Règlement Général sur la Protection des Données (RGPD). Pour en savoir plus, consultez notre{" "}
            <a
              href="https://www.iubenda.com/privacy-policy/64553210"
              className="text-accent hover:underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              Politique de confidentialité
            </a>.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-foreground mb-3">Cookies</h2>
          <p className="text-muted-foreground leading-relaxed">
            Ce site utilise des cookies. Pour en savoir plus, consultez notre{" "}
            <a
              href="https://www.iubenda.com/privacy-policy/64553210/cookie-policy"
              className="text-accent hover:underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              Politique relative aux cookies
            </a>.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-foreground mb-3">Contact</h2>
          <p className="text-muted-foreground leading-relaxed">
            Pour toute question relative au site ou à vos données personnelles :{" "}
            <a href="mailto:gregory.s@coach-os.eu" className="text-accent hover:underline">gregory.s@coach-os.eu</a>
          </p>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default MentionsLegales;
